<template>
  <div class="page">
    <!--头部图片-->
    <van-sticky>
      <div class="m-pic"><img src="@/assets/img/home/Mask group.png" alt=""></div>
    </van-sticky>
    <!--列表 上拉加载-->
    <div class="m-list-box">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
      >
        <!-- 下拉刷新 -->
        <van-pull-refresh
            v-model="isLoading"
            success-text="刷新成功"
            @refresh="onRefresh"
        >
          <div class="m-content">
            <div class="m-box x-flex-between" v-for="(item,index) in dataList" :key="item.noticeId" @click="goTo(item.noticeId)">
              <div class="m-left">
                <div class="m-des">
                  <!--<em>置顶</em>-->
                  {{item.noticeTitle}}
                </div>
                <span>{{item.createTime}}</span>
              </div>
              <van-icon class="m-ice" name="arrow" />
            </div>
          </div>
        </van-pull-refresh>
      </van-list>
    </div>
  </div>
</template>

<script>

  export default {
    components: {},
    data () {
      return {
        dataList:[],
        loading: false,
        finished: false,
        isLoading:true,
        pageNum: 1,
        pageSize: 15,
        count: 0,
      }
    },
    created () {
//      this.getList()
    },
    methods: {
      onLoad() {
        if(this.isLoading){
          this.dataList = []
          this.pageNum = 1
          this.isLoading = false
        } else {
          this.pageNum++
        }
        this.getList()
      },
      onRefresh() {
        this.finished = false
        this.loading = true
        this.onLoad()
      },
      getList(bol){
        this.http.getRequest({
          url:'app/userInfo/list',
          msg:{
            noticeType:2,
            pageNum: this.pageNum,
            pageSize: this.pageSize
          },
          success:(res)=>{
            this.count = res.total
            this.dataList = this.dataList.concat(res.rows)
            this.loading = false
            if(this.dataList.length >= this.count){
              this.finished = true
            }
          }
        })
      },
      goTo(i){
        this.$router.push({
          path:'/newsDetail',
          query:{
            noticeId:i
          }
        })
      }
    },
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";
 .page{
   background: #F4F6F9;
   .m-pic{
     width: 100%;
     >img{
       width: 100%;
     }
   }
   .m-list-box{
     margin-bottom: 50px;
     .m-content{
       padding: 15px 12px 0 12px;
       .m-box{
         background: #FFFFFF;
         border-radius: 4px 4px 4px 4px;
         margin-bottom: 12px;
         padding: 15px 12px;
         .m-left{
           flex: 1;
           margin-right: 10px;
           .m-des{
             font-weight: bold;
             line-height: 20px;
             margin-bottom: 10px;
             height: 40px;
             -webkit-line-clamp: 2; // 设置两行文字溢出
             display: -webkit-box;
             -webkit-box-orient: vertical;
             overflow: hidden;
             >em{
               font-size: 12px;
               padding: 3px 6px;
               background: #FFE8E8;
               color: #FB2927;
               border-radius: 2px 2px 2px 2px;
               margin-right: 3px;
             }

           }
         }
         .m-ice{
           font-size: 18px;
           color: #767A7F;
         }
       }
     }
   }

 }
</style>

